<template>
    <div  style="margin-bottom:50px">
        <div class="tit-head">
            <div>多选题</div>
            <!-- <div class="stem" v-html="info.title"></div> -->
            <mavonEditor 
                :boxShadow="false" 
                styleEditor="min-height: 20px;width: auto;" 
                :content="info.title" 
                :subfield="false" 
                :toolbarsFlag="false" 
                previewBackground="#fff"
                defaultOpen="preview" 
            />
        </div>
        <div class="multiple">
            <Checkbox-group v-model="info.yourAnswer" vertical @on-change="change">
                <Checkbox label="A">
                    <div>A、</div>
                    <mavonEditor 
                        :boxShadow="false" 
                        styleEditor="min-height: 20px;width: auto;" 
                        :content="info.optionsA" 
                        :subfield="false" 
                        :toolbarsFlag="false" 
                        previewBackground="#fff"
                        defaultOpen="preview" 
                    />
                </Checkbox>
                <Checkbox label="B">
                    <div>B、</div>
                    <mavonEditor 
                        :boxShadow="false" 
                        styleEditor="min-height: 20px;width: auto;" 
                        :content="info.optionsB" 
                        :subfield="false" 
                        :toolbarsFlag="false" 
                        previewBackground="#fff"
                        defaultOpen="preview" 
                    />
                </Checkbox>
                <Checkbox label="C">
                    <div>C、</div>
                    <mavonEditor 
                        :boxShadow="false" 
                        styleEditor="min-height: 20px;width: auto;" 
                        :content="info.optionsC" 
                        :subfield="false" 
                        :toolbarsFlag="false" 
                        previewBackground="#fff"
                        defaultOpen="preview" 
                    />
                </Checkbox>
                <Checkbox label="D" v-if="info.optionsD">
                    <div>D、</div>
                    <mavonEditor 
                        :boxShadow="false" 
                        styleEditor="min-height: 20px;width: auto;" 
                        :content="info.optionsD" 
                        :subfield="false" 
                        :toolbarsFlag="false" 
                        previewBackground="#fff"
                        defaultOpen="preview" 
                    />
                </Checkbox>
                <Checkbox label="E" v-if="info.optionsE">
                    <div>E、</div>
                    <mavonEditor 
                        :boxShadow="false" 
                        styleEditor="min-height: 20px;width: auto;" 
                        :content="info.optionsD" 
                        :subfield="false" 
                        :toolbarsFlag="false" 
                        previewBackground="#fff"
                        defaultOpen="preview" 
                    />
                </Checkbox>
                <Checkbox label="F" v-if="info.optionsF">
                    <div>F、</div>
                    <mavonEditor 
                        :boxShadow="false" 
                        styleEditor="min-height: 20px;width: auto;" 
                        :content="info.optionsF" 
                        :subfield="false" 
                        :toolbarsFlag="false" 
                        previewBackground="#fff"
                        defaultOpen="preview" 
                    />
                </Checkbox>
            </Checkbox-group>
        </div>
    </div>
</template>
<script>
import mavonEditor from './mavonEditor.vue'
export default {
    components:{ mavonEditor },
    props:{
        info:{
            type:Object,
            default:null
        },
        correctAnswer:{
            type:String,
            default:null
        }
    },
    data(){
        return{
            multipleAnswer:[]
        }
    },
    created(){
        if(this.correctAnswer){
            this.multipleAnswer = this.correctAnswer.split(',')
            console.log(this.correctAnswer.split(','),'correctAnswer')

        }
        // console.log(this.info)
    },
    methods:{
        change(){
            this.$emit('childQuestionFn', {answer:this.info.yourAnswer, questionId: this.info.id});
        }
    }
}
</script>
<style lang="less" scoped>
@import './style/common.less';
.multiple {
    margin-left: 60px;
    /deep/ .ivu-checkbox-wrapper {
        display: flex;
        margin: 10px 0 10px 10px;
        height: auto;
        span:nth-child(2) {
            display: inline-flex;
        }
        .ivu-radio {
            margin-top: 8px;
        }
    }
    /deep/ .ivu-checkbox-group {
        display: flex;
        flex-direction: column;
    }
    /deep/ .ivu-checkbox-inner {
        border-radius: 50%;
        margin-right: 10px;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/practise/components/questionMultiple.vue